import { ResumeAnalysis } from "lib/resume-scoring/resume-analysis/resume-analyse-types";

/**
 * Removes invalid grammar mistakes (where both correct and incorrect are null) from resume analysis
 * @param analysis The original resume analysis
 * @returns Updated resume analysis with void grammar mistakes removed
 */
export const removeVoidGrammarMistakes = (analysis: ResumeAnalysis): ResumeAnalysis => {
  // Handle null/undefined analysis
  if (!analysis) return analysis;
  
  // Create a deep copy of the analysis to avoid mutating the original
  const cleanedAnalysis = JSON.parse(JSON.stringify(analysis)) as ResumeAnalysis;
  
  // Helper function to filter out void grammar mistakes
  const filterVoidGrammarMistakes = (grammarMistakes: Array<any>) => {
    if (!grammarMistakes) return [];
    
    return grammarMistakes.filter(mistake => {
      // Skip if mistake is undefined
      if (!mistake) return false;
      
      // Keep the mistake if either correct or incorrect is not null
      return mistake.correct !== null || mistake.incorrect !== null;
    });
  };
  
  // Clean profile summary analysis
  if (cleanedAnalysis.profile?.summaryAnalysis?.analysis?.grammarMistakes) {
    cleanedAnalysis.profile.summaryAnalysis.analysis.grammarMistakes = 
      filterVoidGrammarMistakes(cleanedAnalysis.profile.summaryAnalysis.analysis.grammarMistakes);
  }
  
  // Clean work experiences analysis
  if (cleanedAnalysis.workExperiences?.individualWorkExperiencesAnalysis) {
    for (const experience of cleanedAnalysis.workExperiences.individualWorkExperiencesAnalysis) {
      if (experience.descriptionAnalysis) {
        for (const desc of experience.descriptionAnalysis) {
          if (desc.analysis?.grammarMistakes) {
            desc.analysis.grammarMistakes = filterVoidGrammarMistakes(desc.analysis.grammarMistakes);
          }
        }
      }
    }
  }
  
  // Clean educations analysis
  if (cleanedAnalysis.educations?.individualEducationsAnalysis) {
    for (const edu of cleanedAnalysis.educations.individualEducationsAnalysis) {
      if (edu.descriptionAnalysis) {
        for (const desc of edu.descriptionAnalysis) {
          if (desc.analysis?.grammarMistakes) {
            desc.analysis.grammarMistakes = filterVoidGrammarMistakes(desc.analysis.grammarMistakes);
          }
        }
      }
    }
  }
  
  // Clean projects analysis
  if (cleanedAnalysis.projects?.individualProjectsAnalysis) {
    for (const project of cleanedAnalysis.projects.individualProjectsAnalysis) {
      if (project.descriptionAnalysis) {
        for (const desc of project.descriptionAnalysis) {
          if (desc.analysis?.grammarMistakes) {
            desc.analysis.grammarMistakes = filterVoidGrammarMistakes(desc.analysis.grammarMistakes);
          }
        }
      }
    }
  }
  
  // Clean custom sections
  if (cleanedAnalysis.custom?.descriptionAnalysis) {
    for (const desc of cleanedAnalysis.custom.descriptionAnalysis) {
      if (desc.analysis?.grammarMistakes) {
        desc.analysis.grammarMistakes = filterVoidGrammarMistakes(desc.analysis.grammarMistakes);
      }
    }
  }
  
  return cleanedAnalysis;
};



